var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen flex"},[_c('div',{staticClass:"w-60"},[_c('sideBarDok')],1),_c('navBarDok'),_c('div',{staticClass:"h-full flex flex-col w-full pb-0",staticStyle:{"padding-top":"71px"}},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var Component = ref.Component;
return [_c(Component,{tag:"component"})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }